// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://appataxi.cab/web_app/public",
  baseUrl: "https://appataxi.cab/driver_app/",
  // baseUrl: "http://localhost:4200/",
  // apiUrl: "http://44.219.79.202/web_app/public",
  // apiUrl: "https://appacab.world/web_app/public",
  // baseUrl: "https://appacab.world/driver_app/",
  // apiUrl: "http://44.219.79.202/web_app/public",
  // apiUrl: "https://stagingpc.com/web_app/public",
  // baseUrl: "http://localhost:4200/",
  firebase: {
    apiKey: "AIzaSyD2EmXo43POdNbBaC77SRNTL4PPAQnnmMk",
    authDomain: "appataxi-1e1f0.firebaseapp.com",
    databaseURL: "https://appataxi-1e1f0.firebaseio.com",
    projectId: "appataxi-1e1f0",
    storageBucket: "appataxi-1e1f0.appspot.com",
    messagingSenderId: "377982103883",
    appId: "1:377982103883:web:46cc5cf1db57431a",
    vapidKey: "BNXMbVaJt8Ju2mlIv79ePnZOY9RyEPQYdS2OZIdhr3JsUoQajAlvbDx9ouRai_YSvMWcSc6-fkYogKgrVPqRgx4"
  },
  google: {
    mapApiKey: "AIzaSyBP-RQNwkQGDL0CxqlBSKscf1jJvyyrslo",
    // LAST-RESORT map view only. The dashboard first tries, in order: the live
    // GPS fix, the driver's last position stored on the server (users.lat/lng,
    // returned by /api/driver/information), then the last position cached on
    // this device. This constant is used only when all three are unavailable —
    // i.e. a brand-new driver on a new device with location blocked.
    // Thanet District, Kent (the operating area).
    defaultMapCenter: { lat: 51.3602516, lng: 1.3484663 },
    defaultMapZoom: 12
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
